<template>
  <Card>
    <CardHeading
      heading="Categories"
      :show-button="false"
      :show-capacity="false"
    />
    <div class="grid__cell col12-of-12--medium-up" style="padding-left: 0">
      <label v-if="categories && categories.length > 0" class="mb-sm"
        >Categories</label
      >
      <div
        v-for="category in categories"
        :key="category.id"
        class="custom-checkbox custom-checkbox-tick"
      >
        <input
          type="checkbox"
          :id="category.id"
          @change="handleCheckboxChange(category.id)"
          :checked="checkCategories(category.id)"
          :value="category.id"
        />
        <label :for="category.id">{{ category.name }}</label>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/DesignSystem/Card.vue';
import CardHeading from '@/components/DesignSystem/CardHeading';

export default {
  components: {
    Card,
    CardHeading,
  },
  props: {
    namespace: String,
    categories: {
      type: Array,
    },
    profileCategories: {
      type: Array,
    },
  },
  methods: {
    checkCategories(id) {
      if (!this.categories) return false;
      for (let category of this.profileCategories) {
        if (category.id === id || category === id) {
          return true;
        }
      }
      return false;
    },

    handleCheckboxChange(id) {
      this.$store.dispatch(`${this.namespace}/handleCheckboxChange`, id);
    },
  },
};
</script>
